import React from 'react';
import SecondsTrendWidget, { TrendWidgetProps } from './SecondsTrendWidget';

// Sourced from POST /api/widgets/key-metrics widget type 13; `value` is AWT in whole seconds.
const AverageWaitingTimeTrendWidget: React.FC<TrendWidgetProps> = (props) => (
  <SecondsTrendWidget
    {...props}
    title="Average Wait Time Trend"
    description="The pattern of average amount of time that the callers had to wait for an agent to answer within a given time."
    tooltipLabel="Average Wait Time"
  />
);

export default AverageWaitingTimeTrendWidget;
